export default "__VITE_ASSET__BQuzLIIe__"